import axios from 'axios';
import * as types from '../store/mutation-type';
import store from '../store/index';

/**
 * 封装fetch
 * @param path
 * @param params
 * @returns {*|Promise|Promise.<T>|Promise<U>}
 */
export default function toFetch(path, params, config) {
  let {
    //TODO:
    url = process.env.VUE_APP_ENV == 'development' ? '/surveyapi' : process.env.VUE_APP_ENV == 'pre' ? '//gapi.dev.ztgame.com/surveyapi' : '//gapi.ztgame.com/surveyapi', // pre: gapi.dev.ztgame.com
    type = 'POST',
    contextType = 'application/json'
  } = config || {};

  url = `${url}${path}`;


  return axios(type === 'POST' ? {
    method: type,
    url,
    withCredentials: true,
    headers: {
      'Content-Type': contextType
    },
    data: params
  } : {method: type, url, withCredentials: true})
    .then(res => {
        if (res.data.code != 1) {
          if (res.data.errors) {
            let keys = Object.keys(res.data.errors)
            if (res.data.errors[keys[0]] && !/login$/.test(path)) {
              store.commit(types.SHOW_MODAL, {
                name: 'message',
                msg: res.data.errors[keys[0]][0]
              });
            }
          }
        } else {
          return res.data;
        }
    })
    .catch(function (err) {
      store.commit(types.SHOW_MODAL, {
        name: 'message',
        msg: err.message
      });
      return {}
    })
}
